<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent-fm"><a id="page_ic"></a><a id="page_iv"></a><a id="page_v"></a><em class="italic">I am not a great man, but sometimes I think the impersonal and objective quality of my talent, and the sacrifices of it, in pieces, to preserve its essential value has some sort of epic grandeur.</em></p>
<p class="noindent-fm1">—F. Scott Fitzgerald</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dadication.vue?bf521162